import { Tooltip } from '@chakra-ui/react'

export default function ChakraTooltip({children, ...props}) {
    return (
        <Tooltip {...props} overflow="initital">
            {children}
        </Tooltip>
    );
}
